import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { create } from 'kts-scaffold-framework/utils/form';
import { Urls } from 'kts-platform-frame/entry/constant';
// import UIDeptTreeSelect from './UI.Deprtment.TreeSelect';
import { Button, Row, Col, Form, Modal, Avatar, Input, Tabs, Spin, TreeSelect } from 'antd';  
const Search = Input.Search;
const TabPane = Tabs.TabPane;
const SHOW_PARENT = TreeSelect.SHOW_ALL; 
const css = require('./index.scss'); 
/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))

export default class UIComponents extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction); 
    }
    componentWillMount (){
        ModulesAction.permissionQuery();
    }  
    componentDidMount(){ 
        ModulesAction.departmentQuery();
        ModulesAction.permissionDepQuery();
    }
    render() {
        const { loadingUrls } = this.props;
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const treeData = this.modulesState.departtreeDate;  
        const tProps = {
            treeData, 
            treeDefaultExpandAll: true, 
            // onChange: this.onChange, 
            treeCheckable: true,  
            treeCheckStrictly: true, 
            treeNodeFilterProp: 'label',
            showCheckedStrategy: SHOW_PARENT,
            searchPlaceholder: '请选择部门',  
            style: {
                width: '85%', 
            },
            // onSearch: this.onSearch,
            dropdownStyle: { maxHeight: 400, overflow: 'auto' },
            allowClear: false,  
        }; 
        return (
            <div className={`${css.authority} asideroverall`}>
                <Spin spinning={loadingUrls.size > 0}>
                    <Tabs defaultActiveKey="1" className={`title16`} animated={false} onChange={ModulesAction.onChangeTab}>
                        <TabPane tab="协作成员" key="1">
                            <div className={css.authorityContent} style={{ maxHeight: 'calc(100vh - 270px)'}}>
                                {this.getPermissionUserObjects()}
                                { 
                                    !this.modulesState.permissionUserObjects.length &&
                                    <p style={{textAlign: 'center'}}>暂无成员</p>
                                }
                            </div> 
                        </TabPane>
                        <TabPane tab="公司成员" key="2">
                            <div className={css.search}>
                                <Search
                                    placeholder="请输入姓名"
                                    onSearch={value => ModulesAction.onSearch(value)}
                                />
                            </div>
                            <div className={css.authorityContent}>
                                
                                {this.getCompanyUserList()}
                                <div style={{textAlign: 'center',marginTop: '10px'}}>
                                {
                                    this.modulesState.companyUserList.length < this.modulesState.pageMeta.total ?
                                    <a onClick={() => { ModulesAction.loadingMore();}}>加载更多</a> :
                                    <p>没有更多</p>
                                }
                                </div>
                            </div> 
                        </TabPane>
                        <TabPane tab="部门管理" key="3">  
                            {/* <UIDeptTreeSelect />    */}
                            <div> 
                                <Form style={{textAlign: 'center', height:550}}>
                                    <Form.Item>
                                        {getFieldDecorator('deptpermision', {
                                            initialValue: this.modulesState.permissionDepObjectsValues, 
                                        })(<TreeSelect {...tProps} />)}
                                    </Form.Item>  
                                </Form> 
                            </div>
                        </TabPane>
                    </Tabs>
                </Spin>
                    <div className={css.authorityFooter}>
                        {this.modulesState.tabchange === '3' && <Button type="primary" onClick={this.changeDeptPermision} className={css.surebtn} htmlType="submit" >确认</Button>}
                        {/* <Button type="primary" onClick={ModulesAction.submitAuthority} style={{ background: '#188fff'}}>确认</Button> */}
                        <Button className={css.mb30} onClick={ModulesAction.closeShowPanel} >取消</Button>
                    </div>
                
            </div>
        );
    }
    /** 获取授权app用户列表 */
    private getPermissionUserObjects() {
        let tempArr = [];
        this.modulesState.permissionUserObjects.forEach( item => {
            tempArr.push(
                <div className={css.listItem} key={item.objectId}>
                    <Avatar className={css.userIcon} icon="user" /><span>{item.objectName}</span>
                    <Button size="small" className={css.userBt} onClick={() => ModulesAction.remove(item.objectId)}>移除</Button>
                </div>
            );
        });
        return tempArr;
    }
    /** 获取公司用户列表 */
    private getCompanyUserList() {
        let tempArr = [];
        this.modulesState.companyUserList.forEach(item => {
            let hasPermission = false;
            this.modulesState.permissionUserObjects.forEach(permissionitem => {
                if (permissionitem.objectId === item.userId) {
                    hasPermission =  true;
                }
            });
            tempArr.push(
                <div className={css.listItem} key={item.userId}>
                    <Avatar className={css.userIcon} icon="user" /><span>{item.nickName}</span>
                    {
                        hasPermission ? <Button onClick={ () => ModulesAction.remove(item.userId)} size="small" className={css.userBt}>移除</Button> :
                            <Button onClick={() => ModulesAction.add(item.userId)} size="small" className={css.userBt} style={{ background: '#188fff' }} type="primary">添加</Button>
                    }
                </div>
            );
        });
        return tempArr;
    }  
    private changeDeptPermision = () => { 
        this.props.form.validateFields(async (er: any, values: any) => {  
            if (er) {
                return;
            } 
            let params = [];
            /** 
             * values.deptpermision 格式: [{label:"12",value:"f80f9050-b1c6-44c3-bab8-b74a0a5b8d49"}]
             */ 
            values.deptpermision && values.deptpermision.forEach(element => {
                let param = {
                    objectId: element.value,
                    objectType: 1, // 部门固定写1 
                };
                params.push(param);
            });
            ModulesAction.changeDeptPermision(params);
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppDetail/UI.Authority.tsx